import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { ValueStrip } from "@/components/ValueStrip";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BuildYourRing from "@/pages/BuildYourRing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import BookConsultation from "@/pages/BookConsultation";
import ShippingReturns from "@/pages/ShippingReturns";
import RingResize from "@/pages/RingResize";
import ScrollToTop from "@/components/ScrollToTop";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-[#737373] label-track">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      {!isAdmin && <CartDrawer />}
      <main>
        {!isAdmin && <div className="pt-20"><ValueStrip /></div>}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:category" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/build" element={<BuildYourRing />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/book/consultation" element={<BookConsultation />} />
          <Route path="/policies/shipping-returns" element={<ShippingReturns />} />
          <Route path="/services/ring-resize" element={<RingResize />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    // Strip the injected "Made with Emergent" badge on production
    const strip = () => {
      document.querySelectorAll('#emergent-badge, a[href*="emergent.sh"][id="emergent-badge"]').forEach((el) => el.remove());
    };
    strip();
    const observer = new MutationObserver(strip);
    observer.observe(document.body, { childList: true, subtree: false });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Shell />
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#0A0A0A",
                  border: "1px solid #0A0A0A",
                  color: "#FFFFFF",
                  borderRadius: 0,
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
